import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const socket = defineConnector({
  identifier: "socket",
  name: "Socket",
  tagLine: "Supply chain security for open source",
  logo,
  protocol: "http",
  tags: ["security", "engineering"],
  defaultUrlPattern: () => "https://api\\.socket\\.dev/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API token",
      items: [
        {
          kind: "markdown",
          content:
            "In [Socket](https://socket.dev/dashboard), go to your organization settings and create a new API token.",
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "input",
          label: "Socket API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.socket.dev/v0/organizations",
  },
});
